import * as React from 'react';
import { AlertCircle, Eye, CheckCircle, Info } from 'lucide-react';
import { cn } from './lib/utils';

const TYPE_CONFIG = {
  critical: {
    icon: AlertCircle,
    iconClass: 'text-red-critical',
    bgClass: 'bg-red-bg',
    borderClass: 'border-red-critical/20',
  },
  watch: {
    icon: Eye,
    iconClass: 'text-yellow-nn',
    bgClass: 'bg-yellow-bg',
    borderClass: 'border-yellow-nn/20',
  },
  ok: {
    icon: CheckCircle,
    iconClass: 'text-green-nn',
    bgClass: 'bg-green-bg',
    borderClass: 'border-green-nn/20',
  },
  info: {
    icon: Info,
    iconClass: 'text-aqua',
    bgClass: 'bg-[rgba(8,145,178,0.06)]',
    borderClass: 'border-aqua/20',
  },
};

const DENSITY_CONFIG = {
  compact:  { padding: 'px-2 py-1.5', gap: 'gap-2',   textSize: 'text-body-sm' },
  default:  { padding: 'px-3 py-2.5', gap: 'gap-2.5', textSize: 'text-body'    },
  spacious: { padding: 'px-4 py-3',   gap: 'gap-3',   textSize: 'text-body'    },
};

/**
 * Renders **bold** markdown within text as <strong>.
 */
function renderBoldText(text) {
  const parts = text.split(/\*\*(.*?)\*\*/g);
  return parts.map((part, i) =>
    i % 2 === 1 ? <strong key={i} className="font-semibold">{part}</strong> : part
  );
}

/**
 * A single line item in the HuddleBanner.
 *
 * density="compact" | "default" | "spacious"
 *   Controls padding and gap between icon and text together.
 */
function HuddleSignal({ type = 'info', text, density = 'default', className }) {
  const config = TYPE_CONFIG[type] ?? TYPE_CONFIG.info;
  const dc = DENSITY_CONFIG[density] ?? DENSITY_CONFIG.default;
  const Icon = config.icon;

  return (
    <div
      className={cn(
        'flex items-start rounded border',
        dc.padding,
        dc.gap,
        config.bgClass,
        config.borderClass,
        className
      )}
    >
      <Icon className={cn('h-4 w-4 mt-0.5 shrink-0', config.iconClass)} aria-hidden="true" />
      <p className={cn('text-text-dark leading-snug', dc.textSize)}>{renderBoldText(text)}</p>
    </div>
  );
}

export { HuddleSignal };
